module.exports = __webpack_public_path__ + "static/media/LITHIUM.d3b8ffd9.svg";